import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";

const useIsEditMode = (): boolean => {
  const isEditMode = useSelector((state: RootState) => state.app.isInEditMode);
  return isEditMode;
};

export default useIsEditMode;
